import { useEffect, useRef } from "react";
import { isValidObject } from "../Services/validators";

export function useServiceWorkerMessageSync(
  setOfflineCaptures,
  setOfflineProcedureHistory,
  forceRefreshAccessTokenAndRetryAPI
) {
  // to prevent the call on being unmount
  const isActiveRef = useRef(true);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }
    isActiveRef.current = true;

    const handleSWMessage = async (event) => {
      if (!isValidObject(event.data)) {
        return console.warn("[SW-MSG] Invalid message data received");
      }
      const { type, data } = event.data;

      switch (type) {
        case "QUEUED_FACE_COMPARISON_REQUESTS_UPDATED":
          setOfflineCaptures(data);
          break;

        case "QUEUED_PROCEDURE_HISTORY_REQUESTS_UPDATED":
          setOfflineProcedureHistory(data);
          break;

        case "FORCE_REFRESH_TOKEN":
          forceRefreshAccessTokenAndRetryAPI(data);
          break;

        case "FORCE_UPDATE_AVAILABLE":
          console.warn(
            "[SW-MSG] Update available with build:",
            event.data?.build
          );
          break;

        default:
          console.warn("[SW-MSG] Unknown message type:", type);
          break;
      }
    };

    const requestQueuedData = () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(
          "GET_QUEUED_FACE_COMPARISON_REQUESTS"
        );
        navigator.serviceWorker.controller.postMessage(
          "GET_QUEUED_PROCEDURE_HISTORY_REQUESTS"
        );
      } else {
        console.warn("[SW-REQ] No active SW controller yet");
      }
    };

    const onControllerChange = () => {
      if (isActiveRef.current) {
        requestQueuedData();
      }
    };

    navigator.serviceWorker.addEventListener("message", handleSWMessage);
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      onControllerChange
    );

    if (navigator.serviceWorker.controller) {
      requestQueuedData();
    } else {
      console.warn(
        "[SW-INIT] No controller yet, listening for controllerchange"
      );
    }

    return () => {
      isActiveRef.current = false;
      navigator.serviceWorker.removeEventListener("message", handleSWMessage);
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        onControllerChange
      );
    };
    // eslint-disable-next-line
  }, [
    setOfflineCaptures,
    setOfflineProcedureHistory,
    forceRefreshAccessTokenAndRetryAPI
  ]);
}
